<template>
  <span class="currency">{{ params.value | toCurrency}}</span>
</template>

<script>
export default {
  name: "currency-cell"
};
</script>